var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vp-busy",style:(_vm.style)},[(_vm.busy)?_c('div',{staticClass:"vp-busy__spinner"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }